module.exports = __webpack_public_path__ + "img/blackRules_en.b214af30.png";